import { render, staticRenderFns } from "./SendReport.vue?vue&type=template&id=3d6c5f35&"
import script from "./SendReport.vue?vue&type=script&lang=js&"
export * from "./SendReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports